module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-2.4216888b.svg";